/** Utilidades para corrector ortográfico estilo navegador (palabra bajo el cursor). */

export function getCaretWordBounds(text, caretIndex) {
  const raw = String(text || "");
  const caret = Math.max(0, Math.min(Number(caretIndex) || 0, raw.length));
  let start = caret;
  let end = caret;
  while (start > 0 && /[^\s]/.test(raw[start - 1])) start -= 1;
  while (end < raw.length && /[^\s]/.test(raw[end])) end += 1;
  return { start, end, word: raw.slice(start, end) };
}

export function findMatchCoveringOffset(matches, offset) {
  const pos = Number(offset) || 0;
  return (matches || []).find((match) => {
    const start = Number(match?.offset) || 0;
    const length = Number(match?.length) || 0;
    return length > 0 && pos >= start && pos < start + length;
  });
}

export function normalizeSpellReplacements(match) {
  const raw = match?.replacements;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => (typeof item === "string" ? item : item?.value))
    .filter(Boolean);
}

/** Typos frecuentes en captura manual (respaldo si LanguageTool no responde). */
export const LOCAL_TYPO_SUGGESTIONS = {
  seguimeinto: ["seguimiento"],
  seguimientto: ["seguimiento"],
  seguimineto: ["seguimiento"],
  seguiminto: ["seguimiento"],
  papeleria: ["papelería"],
  documentacion: ["documentación"],
  informacion: ["información"],
  obligacion: ["obligación"],
  declaracion: ["declaración"],
  envio: ["envío"],
  periodo: ["periodo", "período"],
  contabilidad: ["contabilidad"],
  recuerde: ["recuerde"],
  atentamente: ["atentamente"],
};

export function localTypoSuggestions(word) {
  const key = String(word || "").trim().toLowerCase();
  if (!key) return [];
  return LOCAL_TYPO_SUGGESTIONS[key] || [];
}

export function buildMatchForWord(text, bounds, replacements) {
  const list = (replacements || []).filter(Boolean);
  if (!list.length || !bounds?.word) return null;
  return {
    offset: bounds.start,
    length: bounds.end - bounds.start,
    word: bounds.word,
    replacements: list,
  };
}
